import { EventEmitter, Component, Output, Input, ViewChild, ElementRef } from '@angular/core';
import { LanguageOption, LanguageService } from '@service/language.service';

export interface LanguageTextboxInput {
    language: string;
    text: string;
}

@Component({
    selector: 'app-language-textbox',
    templateUrl: './language-textbox.component.html',
    styleUrls: ['./language-textbox.component.css'],
    standalone: false
})
export class LanguageTextboxComponent {
    languageOptions: LanguageOption[];
    @ViewChild('titleInput') titleInput: ElementRef;

    @Output() onInputError = new EventEmitter();

    @Input() excludeLanguages: Set<string> = new Set();
    @Input() includeLanguages: Set<string>;

    allowedRegex = {
        EN: /^[a-zA-Z0-9\s.,!?()-]+$/,
        /*
        For now only English input is restricted
        'JP': /^[\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uFF00-\uFFEF\u4E00-\u9FAF\u3400-\u4DBF]+$/
        */
    };

    selectedLanguage: string;

    hasError: boolean;

    dropdownStyle = {
        display: 'none',
    };

    input = {
        language: '',
        text: '',
    };

    constructor(private languages: LanguageService) {
        this.languageOptions = languages.getLanguages();
    }

    getInputValue() {
        if (this.input.language !== this.selectedLanguage) {
            this.selectedLanguage = this.input.language;
            this.input.text = '';
            return false;
        } else {
            const allowedPattern = this.allowedRegex[this.input.language];
            const validated = allowedPattern?.test(this.input.text);
            if (allowedPattern && !validated && this.input.text !== '') {
                this.onInputError.emit(true);
                return true;
            } else if (this.input.language && this.input.text !== '') {
                this.onInputError.emit(false);
                return false;
            }
            return false;
        }
    }

    shouldInclude(language: LanguageOption) {
        return (
            !this.excludeLanguages.has(language.value) ||
            (this.includeLanguages && this.includeLanguages.has(language.value))
        );
    }

    getLanguageError() {
        if (!this.input.language) {
            this.titleInput?.nativeElement.blur();
            this.onInputError.emit(true);
            return true;
        }
        return false;
    }
}
